import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import Grupo1891 from "../../../assets/img/Grupo1891.png";
import IndustryBannerBgSection from "../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import FLOTA_MARINA_BANNER_RIGHT_IMAGE from "../../../assets/img/FLOTA_MARINA_BANNER_RIGHT_IMAGE.png";
import FLOTA_MARINA_DASHBOARD_IMG from "../../../assets/img/FLOTA_MARINA_DASHBOARD_IMG.png";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";
import { useScrollCtx } from "../../../store/providers/ScrollContext";

const IndustryFlotaMarina = () => {
	const {language} = useLanguageCtx()
	const { dropdownHeader } = useScrollCtx();
  return (
		<>
			<ChangeableHeaderV2
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_yellow_span}
				appearSecondNavbar={dropdownHeader}
				route="flota-marina"
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].flotas_red_title}
					boldText={content[language].flotas_bold_title}
				/>
			</div>

			<div className="top-space-section bottom-space-section">
				<IndustryImageTextSection
					image={{ img: Grupo1891, alt: "Flota Marina" }}
					boldText={content[language].flotas_bold_text}
					paragraphs={content[language].flotas_text}
				/>
			</div>

			<IndustryLightBlueSection checkText={content[language].beneficios_list} />

			<IndustryBannerBgSection route="flota-marina">
				<IndustryImageTextSection
					switchOrder
					inBanner
					yellowText={content[language].caracteristicas_red_text}
					boldText={content[language].caracteristicas_bold_text}
					paragraphs={content[language].caracteristicas_text}
					checkText={content[language].caracteristicas_list}
					image={{ img: FLOTA_MARINA_BANNER_RIGHT_IMAGE, alt: "Barco" }}
				/>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection />

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].dashboard_red_title}
					boldText={content[language].dashboard_bold_title}
				/>
			</div>

			<div className="top-space-section no-top-space-responsive bottom-space-section">
				<IndustryImageTextSection
					image={{ img: FLOTA_MARINA_DASHBOARD_IMG, alt: "Mapa" }}
					boldText={content[language].dashboard_bold_text}
					paragraphs={content[language].dashboard_text}
					checkText={content[language].dashboard_list}
					responsiveImgPosition="last"
				/>
			</div>

			<IndustryFooterButtonSection />
		</>
	);
};

export default IndustryFlotaMarina;
